import { render, staticRenderFns } from "./EditChecklist.vue?vue&type=template&id=388576ec&"
import script from "./EditChecklist.vue?vue&type=script&lang=js&"
export * from "./EditChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports